import React from "react";
import { KG_SIDEBAR_NAV_SECTIONS } from "../../../services/kg/kgSectionRegistry";
import {
  CollapseButton,
  Header,
  HeaderLabel,
  NavItem,
  NavLabel,
  NavList,
  Sidebar,
} from "./KgSecondarySidebar.styles";
import type { KgSecondarySidebarProps } from "./KgSecondarySidebar.types";
import { KG_SECTION_SIDEBAR_ICONS } from "./kgSectionSidebarIcons";

const SidebarToggleIcon = ({ isCollapsed }: { isCollapsed: boolean }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    aria-hidden
  >
    <path
      d="M15.8333 2.5H4.16667C3.24619 2.5 2.5 3.24619 2.5 4.16667V15.8333C2.5 16.7538 3.24619 17.5 4.16667 17.5H15.8333C16.7538 17.5 17.5 16.7538 17.5 15.8333V4.16667C17.5 3.24619 16.7538 2.5 15.8333 2.5Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.5 2.5V17.5"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    {isCollapsed ? (
      <path
        d="M10 12.5L12.5 10L10 7.5"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    ) : (
      <path
        d="M13.3333 12.5L10.8333 10L13.3333 7.5"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    )}
  </svg>
);

const NAV_ITEMS = KG_SIDEBAR_NAV_SECTIONS.map((section) => ({
  id: section.id,
  label: section.sidebarLabel,
  icon: KG_SECTION_SIDEBAR_ICONS[section.id],
}));

export const KgSecondarySidebar: React.FC<KgSecondarySidebarProps> = ({
  activeSection,
  onSectionChange,
  isCollapsed = false,
  onCollapseToggle,
}) => (
  <Sidebar $isCollapsed={isCollapsed}>
    <Header $isCollapsed={isCollapsed}>
      {!isCollapsed && <HeaderLabel>Knowledge Graph</HeaderLabel>}
      <CollapseButton
        onClick={onCollapseToggle}
        title={isCollapsed ? "Expand sidebar" : "Collapse sidebar"}
        aria-label={isCollapsed ? "Expand sidebar" : "Collapse sidebar"}
      >
        <SidebarToggleIcon isCollapsed={isCollapsed} />
      </CollapseButton>
    </Header>

    <NavList>
      {NAV_ITEMS.map(({ id, label, icon }) => {
        const isActive = activeSection === id;
        return (
          <NavItem
            key={id}
            $isActive={isActive}
            $isCollapsed={isCollapsed}
            onClick={() => onSectionChange(id)}
            aria-current={isActive ? "page" : undefined}
            title={isCollapsed ? label : undefined}
          >
            {icon}
            {!isCollapsed && <NavLabel $isActive={isActive}>{label}</NavLabel>}
          </NavItem>
        );
      })}
    </NavList>
  </Sidebar>
);

export default KgSecondarySidebar;
